import { Entity, Field } from "typegraph";

@Entity({many: "programsInfo"})
export class Program {

	@Field()
	public id: number;

	@Field()
	public name: string;

}

@Entity({many: "institutionsInfo"})
export class Institution {

	@Field()
	public guid: any;

	@Field()
	public name: string;

	@Field({entity: Program})
	public programs: [Program];

}


@Entity({many: "getAllUsers"})
export class User {

	@Field()
	public id: number;

	@Field()
	public name: string;

}

@Entity({many: "getAllQuestions"})
export class Question {

	@Field()
	public id: number;

	@Field()
	public questionNumber: string;

	@Field()
	public poolName: string;

	@Field()
	public stem: string;

}

@Entity({many: "getAllQuestions"})
export class QuestionSearch {

	@Field()
	public questionId: number;

	@Field()
	public questionPoolId: number;

	@Field()
	public questionNumber: string;

	@Field()
	public poolName: string;

	@Field()
	public stem: string;

}

@Entity({many: "getQuestionTypes"})
export class QuestionTypes {

	@Field()
	public id: number;

	@Field()
	public name: string;

}

@Entity({many: "getQuestionPools"})
export class QuestionPool {

	@Field()
	public id: number;

	@Field()
	public name: string;

}


// WEBPACK FOOTER //
// ./src/panels/testAssignment/entities/Institution.ts